import { TabProxy } from "encampy";

export async function automateEPlanLogin(
  tab: TabProxy,
  username: string,
  password: string
): Promise<void> {
  // Wait for the login page to load
  await tab.waitForElement("input#accessId", { timeout: 10000 });

  // Type in username and password
  await tab.type("input#accessId", username);
  await tab.type("input#password", password);

  // Click Sign In
  await tab.click("input[type='submit'][value='Sign In']");

  // Wait for navigation to complete after login
  await tab.waitForNavigation({ timeout: 10000 });
}
